import React from 'react';

const StatusBadge = ({ result }) => {
    const isSuccess = result === 'SUCCESS';

    return (
        <span
            className={`pms-update-history-status ${
                isSuccess ? 'pms-update-history-status--success' : 'pms-update-history-status--error'
            }`}
        >
            <i className={`bi ${isSuccess ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
            {isSuccess ? 'Success' : 'Failed'}
        </span>
    );
};

function PmsUpdateHistoryListItem({ item, onViewLogs }) {
    return (
        <article className="pms-update-history-item ecx-page-list-item">
            <div className="pms-update-history-item__header">
                <div className="pms-update-history-item__datetime">
                    <span className="ecx-page-icon-badge" style={{ width: '2.5rem', height: '2.5rem' }}>
                        <i className="bi bi-calendar-check"></i>
                    </span>
                    <div>
                        <div className="fw-normal text-dark">{item.createdAt || '—'}</div>
                        <small className="text-muted">Sync timestamp</small>
                    </div>
                </div>

                <div className="pms-update-history-item__meta">
                    <StatusBadge result={item.result} />
                    {item.pmsType && (
                        <span className="pms-update-history-pms-badge">
                            <i className="bi bi-laptop"></i>
                            {item.pmsType}
                        </span>
                    )}
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => onViewLogs(item)}
                    >
                        <i className="bi bi-journal-text me-1"></i>
                        Check logs
                    </button>
                </div>
            </div>
        </article>
    );
}

export default PmsUpdateHistoryListItem;
